import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { IAdminxStore } from '../../stores';

export function usePreferenceGet(props: ICrudGetProps) {
	const { id, options } = props;
	const { preferenceStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			preferenceStore.getCrud().get(id, options);
		}
	}, [location]);

	if (!id) {
		return null;
	}

	return { error: preferenceStore.getCrud().getHttpError(), isLoading: preferenceStore.getCrud().getIsLoading() };
}
